import api from './api';

const formService = {
  /**
   * List the org's public forms, optionally filtered by project/category.
   */
  async getAll(params = {}) {
    const response = await api.get('/forms', { params });
    return response.data;
  },

  /**
   * Get a single form.
   */
  async getById(id) {
    const response = await api.get(`/forms/${id}`);
    return response.data;
  },

  /**
   * Create a new public intake form.
   */
  async create(formData) {
    const response = await api.post('/forms', formData);
    return response.data;
  },

  /**
   * Update a form (title/description/category/questions/active state).
   */
  async update(id, formData) {
    const response = await api.patch(`/forms/${id}`, formData);
    return response.data;
  },

  /**
   * Delete a form and its submissions.
   */
  async delete(id) {
    const response = await api.delete(`/forms/${id}`);
    return response.data;
  },

  /**
   * List a form's submissions.
   */
  async getSubmissions(formId) {
    const response = await api.get(`/forms/${formId}/submissions`);
    return response.data;
  },

  /**
   * Mark a submission reviewed and/or attach internal notes.
   */
  async updateSubmission(formId, submissionId, data) {
    const response = await api.patch(`/forms/${formId}/submissions/${submissionId}`, data);
    return response.data;
  },

  /**
   * Promote a submission into a tracked Compliance Finding.
   */
  async promoteSubmission(formId, submissionId, data) {
    const response = await api.post(`/forms/${formId}/submissions/${submissionId}/promote`, data);
    return response.data;
  },
};

export default formService;
